module.exports = {
  theme: {
    fontFamily: {
      headings: ['Falster', 'sans-serif'],
      body: ['Fabriga', 'sans-serif']
    },
    extend: {
      colors: {
        brand: {
          bright: '#00FF00',
          pale: '#8cff8c',
          medium: '#00e500',
          dark: '#00d51d',
          darker: '#00b61d',
          'grey-light': '#eaeaea',
          'grey-medium': '#545454',
          'grey-dark': '#353535',
          'dark-cyan': '#122222'
        }
      },
      gridTemplateRows: {
        layout: '130px minmax(400px, auto) minmax(400px, auto) minmax(400px, auto)'
      }
    }
  },
  variants: {},
  corePlugins: {
    // container: false,
    skew: false,
    transform: false
  },
  plugins: []
}
